const setData = [
    {
        id: 1, text: "DJI", age: 3, power: 111, motor: true
    },
    {
        id: 2, text: "HolyStone", age : 11 , power: 17, motor: false
    },

    {
        id:3, text: "JJRC", age : 20 , power: 68, motor: true
    },
    {
        id:4, text: "Potensic", age : 36 , power: 37, motor: false
    }

]

export default setData